import { ShippingType } from "../../../Enums/ShippingType";
import { RequestType } from "../../../Enums/RequestType";
import {
  SourceRequestOrder as requestOrder,
  SourcePbhRequestOrder as pbhRequestOrder,
} from "../../RequestOrder/Components/Constant/Source";
import { OwnerTypeDesc, OwnerType } from "../../../Enums/OwnerTypes";
import { useAuth } from "@airborne/react-admin";

export const SourceRequestOrder = requestOrder;
export const SourcePbhRequestOrder = pbhRequestOrder;
export const SourceCdmHeader = "cdmheaders";
export const SourceCdmSystemTransactionMels = "cdmsystemtransactionmels";

export const RequestTypeChoices = [
  { id: RequestType.PBH, name: "PBH" },
  { id: RequestType.RBH, name: "RBH" },
];
export const ShippingTypeChoices = [
  { id: ShippingType.PBH, name: "PBH" },
  { id: ShippingType.RBH, name: "RBH" },
];
export const PnSelectionChoices = [
  { id: false, name: "Customer Request" },
  { id: true, name: "Pre Defined" },
];
export const OffWingChoices = [
  { id: true, name: "True" },
  { id: false, name: "False" },
];
export const LocalRepairChoices = [
  { id: true, name: "Yes" },
  { id: false, name: "No" },
];
export const IsWaitingForCustomeRecordChoices = [
  { id: true, name: "Yes" },
  { id: false, name: "No" },
];
export const ReleaseTypeChoices = (): any[] => {
  const { user } = useAuth();
  return [
    { id: "FAA", name: "FAA" },
    { id: "SHGM", name: "SHGM" },
    { id: "EASA", name: "EASA" },
    { id: "COC", name: "COC", ownerCode: OwnerTypeDesc.find(x => x.Value == OwnerType.SSM)?.Description },
  ].filter(x => (x.ownerCode != null && !user?.isCustomer ? x.ownerCode === user?.ownerCode : true));
};
